import * as React from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import Box from "@mui/material/Box";

import { addPartida, rmAllPartidas } from "store/slice/partidasSlice";

const MarkOverdueDocuments = () => {
    const dispatch = useDispatch();
    const { partidasFiltro } = useSelector(state => state.cobranza);
    
    function seleccionarVencidos()
    {

        Object.keys(partidasFiltro).map(moneda =>{
            const partidasPorMoneda = partidasFiltro[moneda];
            dispatch(rmAllPartidas({moneda}));
            partidasPorMoneda.forEach(partida => {
                if(partida.diasVencimiento !== "")
                { 
                    dispatch(addPartida(partida));
                }
            });
        })
    }

    return <Box sx={{ paddingTop:"5px" }}>
        <button  className={ "btn-alpha-info-2"} type={"submit"} onClick={ () =>{ seleccionarVencidos() } }>
            <i className="fa-regular fa-clock"></i> Seleccionar vencidos
        </button>
    </Box>
}

MarkOverdueDocuments.propTypes = {
    monto:PropTypes.string,
};

export default MarkOverdueDocuments;